import queryString from 'query-string';

export const wms = ({
  request,
  layers = [],
  featureCount,
  bbox = [],
  width,
  styles,
  height,
  x,
  y,
  version,
  defaultOutputFormat,
  namespace,
}) => {
  const args = {
    version,
    request,
    featureCount,
    layers: layers.join(','),
    query_layers: layers.join(','),
    bbox: bbox.join(','),
    x: Math.round(x),
    y: Math.round(y),
    width,
    styles,
    height,
    service: 'WMS',
    outputFormat: defaultOutputFormat,
    format: 'image/png',
    info_format: 'application/json',
  };

  const url = `/geoserver/${namespace}/wms?${queryString.stringify(args)}`;
  return url;
};
